import { css } from "@emotion/css";
import { Chip } from "@octopusdeploy/design-system-components";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import { type ProjectResource, type ReleaseResource, type ChannelResource, type GetReleaseDeploymentBff, type GetReleaseDetailsBffDeploymentTask, type EnvironmentV2Resource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ChannelChip } from "~/components/Chips";
import Section from "~/components/Section";
import { Note } from "~/components/form";
import { EphemeralEnvironmentDeploymentsTable } from "./EphemeralEnvironmentDeploymentsTable";
type EphemeralEnvironmentDeploymentsSectionProps = {
    project: ProjectResource;
    release: ReleaseResource;
    channel: ChannelResource;
    deployments: GetReleaseDeploymentBff[];
    deploymentTasks: GetReleaseDetailsBffDeploymentTask[];
    environments: EnvironmentV2Resource[];
};
const styles = {
    channel: css({
        display: "flex",
        alignItems: "center",
        gap: space[4],
    }),
};
export function EphemeralEnvironmentProgression({ project, release, channel, deployments, deploymentTasks, environments }: EphemeralEnvironmentDeploymentsSectionProps) {
    return (<>
            <Section>
                <Note>In an Ephemeral Environments Channel, each release creates a new ephemeral environment based on the environment name template configured in the channel. Deployments do not progress to further environments.</Note>
                <div className={styles.channel}>
                    Channel: <ChannelChip channelName={channel.Name}/> <Chip backgroundColor={themeTokens.color.chip.filled.background.info} label="Ephemeral Environments" labelColor={themeTokens.color.chip.filled.text.info}/>
                </div>
            </Section>
            <EphemeralEnvironmentDeploymentsTable project={project} release={release} deployments={deployments} deploymentTasks={deploymentTasks} environments={environments}/>
        </>);
}
